import { getAllSessions, editDeleteSession } from '../../utils/api'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../reducers/hooks'
import { userReducer } from '../../reducers/user/userReducer'
import { v4 as uuidv4 } from 'uuid'

interface UseChatHistoryReturn {
  refreshSessions: () => Promise<void>
  saveRename: (sessionIdRename: string, chatName: string) => Promise<void>
  handleDeleteSession: (sessionIdEditDelete: string) => Promise<void>
}

export const useChatHistory = (): UseChatHistoryReturn => {
  const dispatch = useDispatch()
  const platformId = useAppSelector((state) => state.user.platformId) ?? null
  const userEmail = useAppSelector((state) => state.user.email) ?? ''
  const platform = useAppSelector((state) => state.user.platform) ?? null
  const sessionId = useAppSelector((state) => state.user.sessionId) ?? null
  const allSessions = useAppSelector((state) => state.user.chatHistory) ?? []

  const refreshSessions = async (): Promise<void> => {
    try {
      if (platform !== null && platformId !== null && userEmail !== '') {
        const res = await getAllSessions(platform, platformId, userEmail, '50')
        dispatch(userReducer.actions.changeChatHistory(res.payload))
      }
    } catch (err) {
      console.log('Error refreshing sessions:', err)
    }
  }

  const saveRename = async (sessionIdRename: string, chatName: string): Promise<void> => {
    try {
      const payload = {
        session_id: sessionIdRename,
        session_name: chatName ?? '',
        to_be_deleted: false
      }
      await editDeleteSession(sessionIdRename, payload, platform, null)
      await refreshSessions()
    } catch (err) {
      console.log('Error renaming session:', err)
    }
  }

  const handleDeleteSession = async (sessionIdEditDelete: string): Promise<void> => {
    const sessionName = allSessions.find(s => s.session_id === sessionIdEditDelete)?.name ?? null
    try {
      const payload = {
        session_id: sessionIdEditDelete,
        session_name: sessionName,
        to_be_deleted: true
      }
      await editDeleteSession(sessionIdEditDelete, payload, platform, null)
      await refreshSessions()
      const updatedSessions = (platform !== null && platformId !== null && userEmail !== '')
        ? (await getAllSessions(platform, platformId, userEmail, '50')).payload
        : []
      if (sessionIdEditDelete === sessionId) {
        if (updatedSessions.length > 0) {
          const idx = updatedSessions.findIndex((s: { session_id: string }) => s.session_id === sessionIdEditDelete)
          const nextSession = updatedSessions[(idx + 1) < updatedSessions.length ? (idx + 1) : 0]
          dispatch(userReducer.actions.changeSessionId(nextSession.session_id))
        } else {
          const newSessionId = uuidv4()
          dispatch(userReducer.actions.changeSessionId(newSessionId))
        }
      }
    } catch (err) {
      console.log('Error deleting session:', err)
    }
  }
  return { refreshSessions, saveRename, handleDeleteSession }
}
